/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-22 17:33:16
 * @LastEditTime: 2019-10-22 04:05:05
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const env = require('../../static/config')

const store = new Vuex.Store({
  state: {
    count: 1,
    ossLink: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/',
    activityStoreList: [],
    qqMapSDK: env.qqMapSDK,
    linkUrl: env.linkUrl,
    ssoUrl: env.ssoUrl,
    appId: env.appId,
    authorCode: '' // 微信鉴权code
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js